module.exports = "/images/vendor/flag-icon-css/flags/1x1/sx.svg?a724800161ac62624719410741a2a5fb";